import React, { useEffect } from 'react';
import { Breadcrumbs, Button, ToastMessage } from '@cokitchen/cokitchen-components';
import { apiService } from 'services/base.service';
import { useState } from 'react';
import { ROUTE_KEYS } from 'utils/constants';
import PageHeaderText from 'components/base/page-header-text';

import { toast } from 'react-toastify';
import { handleApiError } from 'utils/functions';
import AmountInput from 'components/amount-input';

const StreaksControl = () => {
  const breadCrumbs = [
    { name: 'Maintenance', path: ROUTE_KEYS.MAINTENANCE },
    {
      name: 'Streak Control',
      path: ''
    }
  ];

  const [loading, setLoading] = useState(false);
  const [minimumSpend, setMinimumSpend] = useState<number>();
  const [actionFrequency, setActionFrequency] = useState('Weekly');

  const getStreakControl = async () => {
    try {
      const response = await apiService.get(`loyalty-streak-control`);
      setMinimumSpend(response.data[0]?.minimum_spend ?? undefined);
    } catch (err) {
      handleApiError(err);
    }
  };

  const updateStreakControl = async () => {
    setLoading(true);

    try {
      const updatedData = {
        minimum_spend: minimumSpend
      };

      await apiService.put(`internal/loyalty-streak-control`, {
        data: updatedData,
        isInternal: true
      });
      toast(<ToastMessage type='success' message='Changes have been saved' />);
    } catch (err: any) {
      toast(<ToastMessage type='error' message={err?.response?.data?.message} />);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getStreakControl();
  }, []);

  const updateDisabled =
    minimumSpend === undefined || minimumSpend < 1 || Number.isNaN(minimumSpend);
  return (
    <div className=' md:ml-3 '>
      <Breadcrumbs breadcrumbs={breadCrumbs} />
      <div className=' max-w-[700px] h-auto pr-6 pl-1 pb-6 pt-3  items-center'>
        <PageHeaderText title='Streak Controls' description='Update Streak behaviour' />
        <div>
          <div className='mt-6'>
            <label htmlFor='number-of-pause-days' className='text-sm'>
              Minimum spend
            </label>
            <AmountInput
              onChange={(amount: string) => setMinimumSpend(Number(amount))}
              value={minimumSpend}
              placeholder='10,000'
            />
          </div>
          <div className='mt-6'>
            <label htmlFor='number-of-pause-days' className='text-sm text-[#858585]'>
              Action frequency
            </label>
            <div className='flex items-center h-[50px] border border-gray-2 rounded-md p-1 mt-2 mb-4'>
              <input
                id='action_frequency'
                placeholder='Weekly'
                readOnly
                value={actionFrequency}
                onChange={(e) => setActionFrequency(e.target.value)}
                className='border border-white focus:outline-none w-[650px] h-[40px] pb-1 pl-2 rounded-md mt-2'
              />
            </div>
          </div>
          <Button
            onClick={updateStreakControl}
            className='w-[180px] h-[30px] mt-10 ml-auto'
            variant='block'
            color='primary'
            loading={loading}
            disabled={updateDisabled}>
            Update
          </Button>
        </div>
      </div>
    </div>
  );
};
export default StreaksControl;
